import * as actions from "../actions/actionTypes"
import { items } from "./initialState"

const itemReducer = (state = items, action) => {
    switch (action.type) {
        case actions.ITEM_LIST_REQUEST:
        case actions.ITEM_ADD_REQUEST:
        case actions.ITEM_GET_REQUEST:
            return {
                ...state,
                requesting: true,
                error: false,
                errorBody: null,
                record: null,
            }
        case actions.ITEM_UPDATE_REQUEST:
            return {
                ...state,
                requesting: true,
                error: false,
                errorBody: null,
            }
        case actions.ITEM_LIST_SUCCESS:
            return {
                ...state,
                requesting: false,
                list: action.payload,
            }
        case actions.ITEM_ADD_SUCCESS:
        case actions.ITEM_UPDATE_SUCCESS:
            return {
                ...state,
                requesting: false,
            }
        case actions.ITEM_GET_SUCCESS:
            return {
                ...state,
                requesting: false,
                record: action.payload,
            }
        case actions.ITEM_ADD_ERROR:
        case actions.ITEM_GET_ERROR:
        case actions.ITEM_LIST_ERROR:
        case actions.ITEM_UPDATE_ERROR:
            return {
                ...state,
                requesting: false,
                error: true,
                errorBody: action.payload,
            }
        default:
            return state
    }
}

export default itemReducer;